import cn from "classnames"
import Star from "public/assets/sales-star.svg"

export default function SaleMessage({ blok }) {
  return (
    <section
      className={cn("px-8 pt-32 pb-12", {
        "bg-grayPawprint md:bg-[length:600px]": blok.background === "gray-paws",
      })}
    >
      <div
        className={cn(
          "max-w-screen-xl mx-auto text-center rounded-3xl border-green-apple border-4 pb-6 pt-12 relative px-6",
          {
            "bg-gray-dark text-white": blok.background === "gray-paws",
          }
        )}
      >
        <Star
          className={cn("w-40 sm:w-52 absolute -top-[88px] z-20 right-1/2 translate-x-1/2", {
            "sales-star-gray": blok.background === "gray-paws",
            "sales-star-white": blok.background === "white",
          })}
        />
        <h2
          className={cn("text-m3 lg:text-l1 leading-7 lg:leading-8 pb-3", {
            "text-green-pine": blok.background === "white",
          })}
        >
          {blok.title}
        </h2>
        {blok.body ? <p className="text-s2">{blok.body}</p> : null}
      </div>
    </section>
  )
}
